import React, { useEffect, useState } from "react";

import "./stylesTicketLengthDistribution.css";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";

import dayjs from "dayjs";
import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";
import { Line } from "react-chartjs-2";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";

const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      beginAtZero: true,
      stacked: false,
    },
    yTurnover: {
      beginAtZero: true,

      type: "linear",
      position: "left",
      stacked: false,
      grid: {
        display: true,
        color: "#2F2F39",
        lineWidth: 1,
        drawBorder: false,
        },
      title: {
        display: true,
        text: "Turnover",
      },
    },
    yGGR: {
      beginAtZero: true,

      type: "linear",
      position: "right",
      stacked: false,
      title: {
        display: true,
        text: "GGR",
      },
    },

  },
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    datalabels: {
      display: false,
      anchor: "end",
      align: "start",
      formatter: (value) => value.toLocaleString(),
      color: "black",
      font: {
        family: "Poppins-regular",
        weight: "bold",
      },
    },
    tooltip: {
      enabled: true,
      mode: "index",
      intersect: false,
      backgroundColor: "#252729",
      titleFont: {
        family: "Poppins-regular",
        size: 16,
        weight: "bold",
      },
      bodyFont: {
        family: "Poppins-regular",
        size: 14,
      },
      padding: 15,
      displayColors: true,
      callbacks: {
        label: function (tooltipItem) {
          const label = tooltipItem.dataset.label || "";
          const value = tooltipItem.raw;
          return `${label}: ${Intl.NumberFormat("en-US", {
            currency: "USD",
          }).format(value)}`;
        },
      },
    },
  },
};


function TicketLengthDistribution() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [isLoading, setIsLoading] = useState(false);

  const thisMonthRange = [dayjs().startOf("month"), dayjs().endOf("month")];
  const [dates, setDates] = useState(thisMonthRange);

  const [ticketLengthDistributionData, setTicketLengthDistributionData] =
    useState({
      labels: [],
      datasets: [
        {
          label: "Turnover",
          data: [],
          backgroundColor: "#FD6F27",
          borderColor: "#FD6F27",
          borderWidth: 1,
        },
        {
          label: "GGR",
          data: [],
          backgroundColor: "#6177E8",
          borderColor: "#6177E8",
          borderWidth: 5,
        },
      ],
    });

  const getTicketLengthDistributionData = async (
    queryString = thisMonthRange,
    isQueryString = true
  ) => {
    let startDate = "";
    let endDate = "";

    if (isQueryString) {
      let formattedQueryString = queryString.split("&");
      startDate = dayjs(formattedQueryString[0]).format("YYYY-MM-DD");
      endDate = dayjs(formattedQueryString[1]).format("YYYY-MM-DD");
    } else {
      startDate = queryString[0]?.format("YYYY-MM-DD");
      endDate = queryString[1]?.format("YYYY-MM-DD");
    }

    const params = {
      start_date: startDate,
      end_date: endDate,
    };

    try {
      setIsLoading(true);
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_TICKET_LENGTH_DISTRIBUTION,
        params
      );

      const data = response?.data?.data?.data;
      const labels = data?.map((item) => item?.ticket_length);
      const ggr = data?.map((item) => item?.ggr);
      const turnover = data?.map((item) => item?.turnover);

      const chartData = {
        labels,
        datasets: [
          {
            label: "Turnover",
            data: turnover,
            backgroundColor: "#FD6F27",
            borderColor: "#FD6F27",
            borderWidth: 1,
            type: "line",
            pointRadius: 0,
            yAxisID: "yTurnover", // eixo separado
          },
          {
            label: "GGR",
            data: ggr,
            backgroundColor: "#6177E8",
            borderColor: "#6177E8",
            borderWidth: 1,
            type: "bar",
            yAxisID: "yGGR", // eixo separado
          },
        ],
      };
      setTicketLengthDistributionData(chartData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTicketLengthDistributionData(dates, false);
  }, []);

  return (
    <div className="ticket-length-distribution-container">
      <div className="ticket-length-distribution-header">
        <h2>Ticket Length Distribution</h2>
        <CustomDatePicker
          getData={getTicketLengthDistributionData}
          dates={dates}
          setDates={setDates}
          showPresets={true}
        />
      </div>
      <div className="ticket-length-distribution-chart-container">
        {isLoading ? (
          <div className="ticket-length-distribution-chart-loading">
            <RebetLoader height="100px" width="100px" />
          </div>
        ) : (
          <div className="ticket-length-distribution-chart-container-content">
            <div className="ticket-length-distribution-chart-header">
            <div className="ticket-length-distribution-chart-header-item">
                <div className="ticket-length-distribution-chart-header-item-color turnover"></div>
                <div className="ticket-length-distribution-chart-header-item-label">
                  Turnover
                </div>
              </div>
              <div className="ticket-length-distribution-chart-header-item">
                <div className="ticket-length-distribution-chart-header-item-color ggr"></div>
                <div className="ticket-length-distribution-chart-header-item-label">
                  GGR
                </div>
              </div>

            </div>
            <div className="ticket-length-distribution-chart">
              <Line data={ticketLengthDistributionData} options={options} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TicketLengthDistribution;
